import { useState } from "react";

import useInterval from "../useInterval/useInterval";

const useCounter = (count: number) => {
  const [counter, setCounter] = useState<number>(count);
  const [delay, setDelay] = useState<number | null>(1000);

  const counting = () => {
    if (counter === 0) {
      setDelay(null);
    } else {
      setCounter((prev) => prev - 1);
    }
  };

  const restart = () => {
    setDelay(1000);
    setCounter(count);
  };

  useInterval(counting, delay);

  return { counter, restart };
};

export default useCounter;
